// extracted by mini-css-extract-plugin
export default {"homeIcon":"App_homeIcon__BHd8X"};